import MenuIcon from '@mui/icons-material/Menu';
import { Button,Stack } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { IoExitOutline } from "react-icons/io5";
import { UserContext } from "../../context/UserContext";
import { trackEventMatomo } from "../../helpers/matomo";
import { logout } from "../../logout";
import Translation from "../Translation/Translation";

export default function Header() {
  const { isHidden, setIsHidden } = useContext(UserContext);
  const { t } = useTranslation('translation');

  const toggleSidebar = () => {
    trackEventMatomo('navegação global', 'click', 'botão', isHidden ? 'expande menu lateral' : 'recolhe menu lateral');
    setIsHidden(!isHidden);
  };

  const handleLogout = () => {
    trackEventMatomo('navegação global', 'click', 'botão', 'logout');
    logout();
  };

  return (
    <AppBar
      position='static'>
      <Toolbar sx={{ backgroundColor: 'white', color: 'gray' }}>
        <IconButton
          onClick={toggleSidebar}
          size="large"
          edge="start"
          aria-label="menu"
          sx={{ color: 'white' }}
        >
          <MenuIcon fontSize='large' sx={{ backgroundColor: '#2EA689' }} />
        </IconButton >
        <Stack
          width={'100%'}
          direction="row"
          alignItems="center"
        >
          <Stack
            width={'100%'}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Translation />
          </Stack>
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={12}
          >
            <Button sx={{ color: 'gray' }} onClick={handleLogout} endIcon={<IoExitOutline />}>
              {t('header.exitButton')}
            </Button>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>

  );
}
